import React, { useState } from 'react';
import {
    GameRowList,
    GameName,
    SupplierName,
    ImageWrapper,
    ImagePlaceholder,
    LeftSide,
    RightSideList,
    GameImageWrapperLazy,
} from 'src/components/CmsCasinoManagement/GameRow/GameRow.style';
import { observer } from 'src/utils/mobx-react';
import { ProviderGameType } from 'src/domains/casino/models/models';

function stopPropagation(e: React.DragEvent<HTMLDivElement>): void {
    e.stopPropagation();
}

interface GameRowPropsType {
    game: ProviderGameType;
}

export const GameRowProvider = observer('GameRowProvider', (props: GameRowPropsType) => {
    const { game } = props;
    const [isDragged, setIsDragged] = useState(false);
    const displayStudio = game.studio.name !== '' && game.studio.name.toLowerCase() !== game.providerName.toLowerCase();

    const onDragStart = (e: React.DragEvent<HTMLDivElement>, elementData: ProviderGameType): void => {
        e.dataTransfer.effectAllowed = 'move';
        setIsDragged(true);
        e.dataTransfer.setData('text/plain', JSON.stringify(elementData));
    };

    const onDragEnd = (): void => {
        setIsDragged(false);
    };

    return (
        <GameRowList
            onDragStart={(e: React.DragEvent<HTMLDivElement>): void => onDragStart(e, game)}
            onDragEnd={onDragEnd}
            draggable
            isDragged={isDragged}
            onClick={stopPropagation}
            data-test='game-row-list'
        >
            <LeftSide>
                <ImageWrapper>
                    {game.imageUrl === '' ? (
                        <ImagePlaceholder>No image</ImagePlaceholder>
                    ) : (
                        <GameImageWrapperLazy
                            imgSrc={game.imageUrl}
                            alt={game.name}
                        />
                    )}
                </ImageWrapper>
                <GameName data-test='game-name'>{game.name}</GameName>
            </LeftSide>
            <RightSideList>
                <SupplierName>
                    {game.providerName}
                    {displayStudio ? ` | ${game.studio.name}` : null}
                </SupplierName>
            </RightSideList>
        </GameRowList>
    );
});
